import { useMemo, useState, useCallback } from "react";

import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Heading,
  Stack,
  // useDisclosure,
  // List,
} from "@chakra-ui/react";

import { useHistory, useParams } from "react-router-dom";

// import Arrow from "assets/svg/icons-new/arrow.svg";

import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
// import Select from "components/Select/Select";
// import Input from "components/Input/Input";
// import SuccessModal from "components/Modals/Success";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

// import HistoryItem from "components/AffiliateItems/HistoryItem";
// import DetailItem from "components/DetailItem/DetailItem";

import AffiliateWallet from "components/AffiliateWallet/AffiliateWallet";
import AffiliateTransactions from "components/AffiliateTransactions/AffiliateTransactions";

import {
  useGetAffiliateEarningSummaryQuery,
  useGetAffiliateTransactionsQuery,
} from "services/walletApi";

// import constant from "config/constant";
// import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";
import { toQueryString } from "util/utils";

export default function RewardHistoryCoinDetails(props) {
  //   const { userData } = props;

  const { coin } = useParams();

  const history = useHistory();

  const [state, _setState] = useState({
    page: 1,
    limit: 10,
    unit: coin,
  });

  const setState = useCallback(
    (newState) => _setState(() => ({ ...state, ...newState })),
    [state]
  );

  const queries = useMemo(() => toQueryString(state), [state]);

  const { data: summaryData /*isLoading: isSummaryLoading*/ } =
    useGetAffiliateEarningSummaryQuery();

  const { data, isLoading, isFetching } =
    useGetAffiliateTransactionsQuery(queries);

  const earnings = useMemo(() => data?.earnings, [data]);
  const totalCount = useMemo(() => data?.totalCount, [data]);

  const combinedEarns = useMemo(
    () => summaryData?.combinedEarns,
    [summaryData]
  );

  const balance = useMemo(
    () => combinedEarns && combinedEarns[coin],
    [combinedEarns, coin]
  );

  console.log("COMBINED EARNINGS", combinedEarns, balance);

  //   const toast = useToast();
  //   const loaded = useRef(false);
  //   const history = useHistory();
  // const { isOpen, onOpen, onClose } = useDisclosure();
  //   const [state, _setState] = useState({ type: "price" });

  //   const setState = (newState) => _setState(() => ({ ...state, ...newState }));

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <Box
          className="account-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 35vw)"]}
            m="0"
            p={[0, 0, "1rem"]}
          >
            <Stack mx={["24px", 0]} mb={["24px", "32px"]}>
              <Heading>{toCoinLocale(coin)} Wallet</Heading>
              <Breadcrumb
                className="animate__animated animate__fadeInDown"
                separator={
                  <ArrowForwardIosRoundedIcon
                    style={{ fontSize: ".8em", color: "#6E7191" }}
                  />
                }
              >
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account">
                    Account
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners">
                    Bitmama Partners
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners/view?tab=reward">
                    Reward History
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="">
                    {toCoinLocale(coin)} Wallet
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Stack>

            <Box
              bg="white"
              p={["32px 24px", "32px 24px", "40px 22px"]}
              //   mt={["24px", "10px"]}
              borderRadius={[0, "8px", "16px"]}
            >
              <AffiliateWallet
                coin={coin}
                availableCoins={[coin]}
                balance={balance}
                precision={8}
                forcePrecision
                onPayback={() =>
                  history.push(`/dashboard/wallet/${coin}/withdraw`)
                }
              />

              <AffiliateTransactions
                page={state?.page}
                limit={state?.limit}
                totalCount={totalCount}
                isLoading={isLoading}
                isFetching={isFetching}
                transactions={earnings}
                mt="40px"
                onNextPage={(next) => setState({ page: next })}
                onFilter={(filter) => setState({ ...filter })}
              />
            </Box>
          </Container>
        </Box>
      </Box>

      {/* <SuccessModal
        isOpen={isOpen}
        onClose={handleClose}
        title="Success"
        message={`Price alert successfully updated `}
      /> */}
    </Box>
  );
}
